import React, { useState, useEffect } from "react";
import axios from "axios";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import './firmalar.css'
import { toast } from "react-toastify";
import { nodeURL } from "../configUrl";
import Swal from 'sweetalert2';
import { findSimilarMatch, normalizeName } from "../utils/similarity";
const Urunler = () => {
  const [searchTerm, setSearchTerm] = useState(""); // Arama inputu
  const [urunler, setUrunler] = useState([]);
  const [showForm, setShowForm] = useState(null); // "add" veya firma ID (edit) olabilir
  const [formData, setFormData] = useState({
    adi: "",
    cinsi: "",
    cinsi_id: null,
    stok_adet: 0,
  });
  const [urunCinsleri, setUrunCinsleri] = useState([]);
console.log(showForm,"sgowform");

  const getInfos =()=>{
    axios
    .get(`${nodeURL}/getUrunler`)
    .then((response) => {
      console.log("Gelen urunler:", response.data);
      setUrunler(response.data);
    })
    .catch((error) => {
      toast.error("Ürünler yüklenirken hata oluştu!", { position: "top-right" });
    });

    axios
    .get(`${nodeURL}/getUrunCinsleri`)
    .then((response) => {
      console.log("Gelen urun cinsleri:", response.data);
      setUrunCinsleri(response.data);
    })
    .catch((error) => {
      toast.error("Ürün Cinsleri hata oluştu!", { position: "top-right" });
    });
  }

  useEffect(() => {
   getInfos()
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleAddFirm = () => {
    setFormData({ adi: "", cinsi: "", cinsi_id: null, stok_adet: 0 });
    setShowForm("add");
  };

  const handleEdit = (firm) => {
    console.log(firm, "firm::");

    setFormData(firm); // Seçilen firmanın verileri formda görünsün
    setShowForm(firm.id); // Güncelleme formunu göster
  };

  const handleSaveFirm = async () => {
    console.log(formData,"formdata");

    if (!formData.adi?.trim() || !formData.cinsi_id) {

        toast.warning("Ürün adı ve cinsi boş bırakılamaz!", { position: "top-right" });
        return;
      }
    if (formData.adi?.trim() && formData.cinsi_id) {
      const parsedStok = Number.isFinite(Number(formData.stok_adet))
        ? Math.max(0, parseInt(formData.stok_adet, 10))
        : 0;
      const payload = { ...formData, stok_adet: parsedStok };
      if (showForm === "add") {
        const similar = findSimilarMatch(formData.adi, urunler, (u) => u.adi);
        if (similar) {
          const confirmText =
            similar.type === "exact"
              ? `"${similar.match.adi}" isminde bir ürün zaten kayıtlı. Yine de eklemek istiyor musunuz?`
              : `"${similar.match.adi}" isimli ürüne benzer bir isim girdiniz. Yine de eklemek istiyor musunuz?`;
          const result = await Swal.fire({
            title: "Emin misiniz?",
            text: confirmText,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Evet, ekle",
            cancelButtonText: "Vazgeç",
          });
          if (!result.isConfirmed) return;
        }

        axios
          .post(`${nodeURL}/createUrunler`, payload)
          .then((response) => {
            console.log("Firma eklendi:", response.data);
        
            getInfos();
            setShowForm(null);
          })
          .catch((error) =>
            console.error(
              "Ekleme Hatası:",
              error.response?.data || error.message
            )
            
          );
      } else {
        axios
          .put(`${nodeURL}/updateUrunler/${formData.id}`, payload)
          .then((response) => {
            console.log("ürün güncellendi:", response.data);
          getInfos();
            setShowForm(null);

            
          })
          .catch((error) =>{
            console.error(
              "Güncelleme Hatası:",
              error.response?.data || error.message
            )
            toast.error("Ürün Güncellenirken hata oluştu!", { position: "top-right" });
       } )
      }
    }
  };

  const handleDelete = (id) => {

    Swal.fire({
      title: 'Emin misiniz?',
      text: 'Seçilen Ürün silinecek!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Evet',
      cancelButtonText: 'Vazgeç',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
        .delete(`${nodeURL}/deleteUrunler/${id}`)
        .then((response) => {
          console.log("Firma silindi:", response.data);
       getInfos();
        })
        .catch((error) =>{
          console.error("Silme Hatası:", error.response?.data || error.message)
          toast.error("Ürün Silinirken hata oluştu!", { position: "top-right" });
     } );
      }
    });

 
  };

  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.2)",
        borderRadius: "15px",
        padding: "20px",
        backdropFilter: "blur(10px)",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      {showForm ? (
     <div className="edit-form-container">
      <h2 className="edit-form-title">{showForm=='add'?'Ürün Ekle':'Ürün Düzenle' }  <CiEdit className="icon" size="22px" /></h2>
     <div className="edit-form">
       <label className="form-label">Ürün Adı:</label>
       <input
         type="text"
         value={formData.adi}
         onChange={(e) =>
           setFormData({ ...formData, adi: e.target.value })
         }
         className="form-input"
       />
   
      
      <label className="form-label">Stok Adedi:</label>
      <input
        type="number"
        value={formData.stok_adet ?? ""}
        onChange={(e) =>
          setFormData({ ...formData, stok_adet: e.target.value })
        }
        min="0"
        className="form-input"
      />

   <label className="form-label">Cinsi:</label>
<select
  value={formData.cinsi_id}
  onChange={(e) => setFormData({ ...formData, cinsi_id: e.target.value })}
  className="form-input"
>
  <option value="">Seçiniz...</option>
  {urunCinsleri.map((cins) => (
    <option key={cins.id} value={cins.id}>
      {cins.cins_adi}
    </option>
  ))}
</select>
   
     
       <div className="form-buttons">
         
         <button onClick={() => setShowForm(null)} className="cancel-button">
           Geri Dön
         </button>
         <button onClick={handleSaveFirm} className="save-button">
         {showForm === "add" ? "Kaydet" : "Güncelle"}
         </button>
       </div>
     </div>
   </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <input
              type="text"
              placeholder="Ürün Ara..."
              value={searchTerm}
              onChange={handleSearch}
              style={{
                padding: "8px",
                border: "1px solid #ccc",
                width: "300px",
                borderRadius:'5px'
              }}
            />
            <button
              onClick={handleAddFirm}
              style={{
                padding: "10px",
                background: "green",
                color: "white",
                border: "none",
                cursor: "pointer",
                marginRight: "20px",
                borderRadius: "10px",
              }}
            >
              Yeni Ürün Ekle
            </button>
          </div>
          <div
            style={{
              display: "flex",
              gap: "16px",
              marginBottom: "10px",
              fontWeight: 600,
            }}
          >
            <span>
              Toplam Stok:{" "}
              {urunler.reduce((acc, u) => {
                const stok = Number(u.stok_adet || 0);
                return Number(u.cinsi_id) === 1 ? acc : acc + stok;
              }, 0)}
            </span>
            <span>
              Kirada:{" "}
              {urunler.reduce((acc, u) => {
                const kirada = Number(u.kirada_adet || 0);
                return Number(u.cinsi_id) === 1 ? acc : acc + kirada;
              }, 0)}
            </span>
            <span>
              Kalan:{" "}
              {urunler.reduce((acc, u) => {
                const stok = Number(u.stok_adet || 0);
                const kirada = Number(u.kirada_adet || 0);
                return Number(u.cinsi_id) === 1 ? acc : acc + Math.max(stok - kirada, 0);
              }, 0)}
            </span>
          </div>
          {urunler.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                marginTop: "20px",
                padding: "10px",
                background: "#f8d7da",
                color: "#721c24",
                borderRadius: "5px",
                fontSize: "16px",
              }}
            >
              Listelenecek firma bulunamadı.
            </div>
          ) :(
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f4f4f4", textAlign: "left" }}>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                  Ürün Adı
                </th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                  Cinsi
                </th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                  Stok
                </th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                  Kirada
                </th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                  Kalan
                </th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                  İşlem
                </th>
              </tr>
            </thead>
            <tbody>
                
              {urunler
                .filter((d) =>
                  normalizeName(d?.adi).includes(normalizeName(searchTerm))
                )
                .map((d) => (
                    
                  <tr key={d.id} style={{ borderBottom: "1px solid #ddd" }}>
                    <td style={{ padding: "10px" }}>{d.adi}</td>
                    <td style={{ padding: "10px" }}>{d.cins_adi}</td>
                    <td style={{ padding: "10px" }}>
                      {Number(d.cinsi_id) === 1 ? "-" : Number(d.stok_adet || 0)}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {Number(d.cinsi_id) === 1 ? "-" : Number(d.kirada_adet || 0)}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {Number(d.cinsi_id) === 1
                        ? "-"
                        : Math.max(
                            Number(d.stok_adet || 0) - Number(d.kirada_adet || 0),
                            0
                          )}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {/* Düzenle Butonu */}
                      <button
                        className="btn btn-sm"
                        onClick={() => handleEdit(d)}
                      >
                        <CiEdit className="icon" size="22px" />
                      </button>
                      {/* Silme Butonu */}
                      <button
                        onClick={() => handleDelete(d.id)}
                  className="btn btn-sm"
                      >
                        <MdDelete className="icon" color="red" size="22px" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          )}
         
        </>
      )}
    </div>
  );
};

export default Urunler;
